import React, { lazy, Suspense } from "react";
import { /* BrowserRouter as */ Router, Switch } from "react-router-dom";
import { createBrowserHistory } from 'history';
//import { AdminRoutes } from './admin-route-provider';
//import { StudentRoutes } from "./student-route-provider";
//import { DonorRoutes } from "./donor-route-provider";

import { CommonRoutes } from "./common-route-provider";
//import { GuestRoutes } from "./guest-route-provider";
import { StoreSubscribe } from "./global-store-provider";
import { AppRoute, getAdminRoles, Loader } from "../components/common/libs/helpers";
import CommonLayout from "../components/common/layout/CommonLayout";
//import Register from "../components/common/screens/register/Register";
//import LogOut from '../components/common/screens/LogOut';
import { AppConfig } from "../config/app";
//import Error from "../components/common/screens/Error";
//Init Route History
const basename = AppConfig.prefix;
export const RouteHistory = createBrowserHistory({ basename });

const StudentRoutes = lazy(() => import("./student-route-provider"));
const DonorRoutes = lazy(() => import("./donor-route-provider"));
const AdminRoutes = lazy(() => import("./admin-route-provider"));
const Register = lazy(() => import("../components/common/screens/register/Register"));
const Error = lazy(() => import("../components/common/screens/Error"));
const LogOut = lazy(() => import('../components/common/screens/LogOut'));
const GuestRoutes = lazy(() => import("./guest-route-provider"));

//Setup App Router
const AppRouter = () => (
  <Router history={RouteHistory}>

    <StoreSubscribe >
      {(store) => {
        let loggedIn = store.state.auth.loggedIn;
        let role = store.state.auth.user.role;
        const completedHisProfile = store.state.auth.user.student !== null;
        if (loggedIn) {
          //Define Admin Routes
          if (getAdminRoles().indexOf(role) !== -1) {
            return <Suspense fallback={<div><RoutePreLoader /></div>}>
              <AdminRoutes />
            </Suspense>
          } else if (role === 'student') {
            //Define Student Routes
            if (!completedHisProfile)
              return <Suspense fallback={<div><RoutePreLoader /></div>}>
                <Switch>
                  {AppRoute({ key: 1, path: "/logout", layout: CommonLayout, component: LogOut })}
                  {AppRoute({ key: 2, path: "*", layout: CommonLayout, component: Register })}
                </Switch>
              </Suspense>
            else
              return <Suspense fallback={<div><RoutePreLoader /></div>}>
                <StudentRoutes />
              </Suspense>
          } else if ('donor' === role) {
            //Define Donor Routes
            return <Suspense fallback={<div><RoutePreLoader /></div>}>
              <DonorRoutes />
            </Suspense>
          }
          else if (role === 'guest') {
            //Define Donor Routes
            return <Suspense fallback={<div><RoutePreLoader /></div>}>
              <GuestRoutes />
            </Suspense>;
          }
          return <Suspense fallback={<div><RoutePreLoader /></div>}><Switch>
            {AppRoute({ key: 2, path: "*", layout: CommonLayout, component: Error })}
          </Switch>
          </Suspense>
        }
        //Define Common Routes
        else
          return <Suspense fallback={<div><RoutePreLoader /></div>}><Switch>{CommonRoutes}</Switch></Suspense>;
      }}
    </StoreSubscribe>
  </Router>

);

const RoutePreLoader = function () {
  return <div id="preloader">
    <div>
      <span style={{ display: "block" }}>Loading<i>.</i><i>.</i><i>.</i></span>
      <div id="preloader-image-cont">
        <img alt="edSeed Logo" src={AppConfig.base + '/logo.png?v1'} />
        <div id="preloader-image-fade" className="fadingEffect"></div>
      </div>
    </div>
  </div>
}

export default AppRouter;